import styled, { DefaultTheme } from 'styled-components';

export const StyledIcon = styled.svg<{ $getColor: (theme: DefaultTheme) => string; $displayOnLoad: boolean }>`
  color: ${({ theme, $getColor }) => $getColor(theme)};
  display: ${({ $displayOnLoad }) => ($displayOnLoad ? 'inherit' : 'none')};
  &.fade-enter {
    opacity: 0;
    display: inherit;
  }
  &.fade-enter-active {
    opacity: 1;
    transition: opacity 500ms;
    display: inherit;
  }
  &.fade-enter-done {
    opacity: 1;
    display: inherit;
  }
  &.fade-exit {
    opacity: 1;
    display: inherit;
  }
  &.fade-exit-active {
    opacity: 0;
    transition: opacity 500ms;
    display: inherit;
  }
  &.fade-exit-done {
    display: none;
  }
`;
